export const WALLET_SYNC_EVENT = "walletSummarySync";

export const requestWalletSummarySync = (reason = "manual") => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(WALLET_SYNC_EVENT, { detail: { reason } }));
};
